import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Checkbox/sgds-checkbox";
import { register } from "../../utils/ce-registry";

register("sgds-checkbox", Component);

export default createComponent({
  react: React,
  tagName: "sgds-checkbox",
  elementClass: Component,
  events: {
    onSgdsChange: "sgds-change",
    onSgdsBlur: "sgds-blur",
    onSgdsFocus: "sgds-focus",
    onSgdsCheck: "sgds-check",
    onSgdsUncheck: "sgds-uncheck"
  }
});
